import React from 'react'
import { Link } from 'react-router-dom'
export default ({  isExpanded}) => {


    return (
        
        <header>
            {isExpanded &&
                <Link to="/">
                    <div className="logo">
                    <span className="site-logo"></span>
                    </div>
                </Link>
            }
                    
                </header>
            )
}